var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileBackground = function SvgMobileBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 360 660"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2413_94905)",
    d: "M-299.881 314.546 47.785 515.324 318.34 359.15-299.881 2.197z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_2413_94905)",
    d: "M-299.878 582.658c0 59.39 64.279 96.417 115.604 66.722L47.788 515.324-300 314.546v267.989z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_2413_94905)",
    d: "m473.293 136.131-657.57-379.682c-51.448-29.696-115.604 7.454-115.604 66.722V2.075l618.344 356.953 154.952-89.452c51.447-29.696 51.447-103.872 0-133.445z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2413_94905",
    x1: -522.289,
    x2: 426.001,
    y1: 20.65,
    y2: 584.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2413_94905",
    x1: -699.235,
    x2: 90.069,
    y1: 210.552,
    y2: 705.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2413_94905",
    x1: -312.467,
    x2: 1305.86,
    y1: -171.33,
    y2: 803.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7A5"
  })))));
};
export default SvgMobileBackground;